import {InfinityScroll} from '../../../design-system/atoms/InfinityScroll/InfinityScroll';
import {DayOfWeekInfiniteListContainer} from '../container/DayOfWeekInfiniteListContainer';
import {
  DayOfWeekCommonProps,
  DayOfWeekLogProps,
  DayOfWeekReferenceKeyProps,
} from '../type';
import {DayOfWeekSection} from './DayOfWeekSection';

interface Props extends DayOfWeekCommonProps, DayOfWeekReferenceKeyProps {
  logProps: DayOfWeekLogProps;
}

export const DayOfWeekLayoutCategory = ({logProps, ...rest}: Props) => {
  return (
    <DayOfWeekSection
      // InfiniteScroll 은 아래로 스크롤 해서 하단 요소가 보여야 다음 요청을 하게 됩니다.
      // 수평 구조가 되면 화면에 항상 로딩이 노출되기 때문에 수직 구조로 변경해야 합니다.
      className="flex-col"
    >
      <DayOfWeekInfiniteListContainer {...rest}>
        {({data, isFetching, hasNextPage, fetchNextPage}) => (
          <InfinityScroll
            isLoading={isFetching}
            canLoadNextPage={hasNextPage}
            requestNextPageData={fetchNextPage}
          >
            <DayOfWeekSection.SingleCategory>
              {data.pages
                .flatMap(page => page.list)
                .map((item, index) => (
                  <DayOfWeekSection.SingleCategory.Item
                    key={`single-category-item-${item.id}-index:${index}`}
                    item={item}
                    cardIndex={index}
                    logProps={logProps}
                  />
                ))}
            </DayOfWeekSection.SingleCategory>
          </InfinityScroll>
        )}
      </DayOfWeekInfiniteListContainer>
    </DayOfWeekSection>
  );
};
